import { AxisScale } from '@visx/axis';

export default function getScaleStep<Scale extends AxisScale>(scale?: Scale) {
  const s = scale as AxisScale;
  return s && 'step' in s ? s?.step() ?? 0 : 0;
}
